import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import {
  AlertBox,
  HouseMagnifyingGlassIcon,
  MediaQuery,
  EarlyExitNoticeWarningBox
} from '@spotahome/ui-library';
import { trans, useSoyuzFlag } from '@spotahome/soyuz/client';
import { DSIcon } from '@spotahome/ui-library/base';

import {
  HowToBookSection,
  HowToBookCollapsableSection
} from './HowToBookSection';
import {
  ThirdSectionContent,
  FourthSectionContent
} from './HowToBookAlertContent';

import './HowToBook.scss';

const HowToBook = ({ hasVetting = false, hasRentCollection = false }) => {
  const [isMobile, setIsMobile] = useState(false);
  const isCopiesOccupanciesAtBookingClosedFlagOn = useSoyuzFlag(
    'CopiesOccupanciesAtBookingClosed'
  ).isOn();

  useEffect(() => {
    setIsMobile(MediaQuery.isMobileScreen());
  }, []);

  const ComponentToRender = isMobile
    ? HowToBookSection
    : HowToBookCollapsableSection;

  const ITEMS = [
    {
      id: 1,
      icon: <DSIcon name="device_portrait" />
    },
    {
      id: 2,
      icon: <DSIcon name="booking_request" />,
      content: isCopiesOccupanciesAtBookingClosedFlagOn
        ? 'listing.how-to-book.no-blocking.2-text'
        : 'listing.how-to-book.2-text'
    },
    {
      isCollapsed: !hasVetting,
      id: 3,
      icon: <DSIcon name="clock" />,
      extraContent: hasVetting ? (
        <AlertBox
          className="how-to-book__alert-box"
          icon={<DSIcon name="check_shield" />}
          iconPosition="top"
          title={trans('listing.how-to-book.paid-plan.3-text.title')}
          message={
            <ThirdSectionContent hasRentCollection={hasRentCollection} />
          }
          roundedCorners
        />
      ) : null
    },
    {
      isCollapsed: !hasVetting,
      id: 4,
      icon: <DSIcon name="key_locker" />,
      extraContent: hasVetting ? (
        <>
          <AlertBox
            className="how-to-book__alert-box"
            icon={<DSIcon name="check_circle" />}
            iconPosition="top"
            title={trans('listing.how-to-book.paid-plan.4-text.title')}
            message={<FourthSectionContent />}
            roundedCorners
          />
          {hasVetting ? (
            <EarlyExitNoticeWarningBox className="how-to-book__alert-box how-to-book__alert-box--early-exit-notice" />
          ) : null}
        </>
      ) : null
    }
  ];

  return (
    <div className="how-to-book">
      <div className="how-to-book__wrapper">
        {ITEMS.map(({ id, icon, content, isCollapsed, extraContent }) => (
          <ComponentToRender
            key={id}
            Icon={icon}
            isCollapsed={isCollapsed}
            extraContent={extraContent}
            title={`listing.how-to-book.${id}-title`}
            content={content || `listing.how-to-book.${id}-text`}
          />
        ))}
      </div>
      {!hasVetting ? (
        <AlertBox
          icon={<HouseMagnifyingGlassIcon />}
          title={trans('listing.how-to-book.alertbox-title')}
          message={trans('listing.how-to-book.alertbox-message')}
        />
      ) : null}
    </div>
  );
};

HowToBook.propTypes = {
  hasRentCollection: PropTypes.string,
  hasVetting: PropTypes.bool
};

export default HowToBook;
